
<template>
  <div class="log-box" ref="logBox">
    <div
      v-for="(log, index) in logs"
      :key="index"
      class="log-line"
      :class="{ success: log.isSuccess, fail: !log.isSuccess }"
    >
      {{ formatTimestamp(log.timestamp) }} :
      {{ log.site }} {{ log.groupName }} {{ log.code }} {{ log.name }} {{ log.failReason }}
      {{ log.message || getFallbackMessage(log) }}
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue';

export default {
  name: 'LogBox',
  props: {
    logs: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.scrollToBottom();
  },
  watch: {
    logs(newLogs) {
      console.log('Logs updated:', newLogs);
      this.$emit('logReceived', newLogs);
      this.scrollToBottom();
    }
  },
  methods: {
    formatTimestamp(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')} ` +
        `${date.getUTCHours().toString().padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}`;
    },
    getFallbackMessage(log) {
      const status = log.isSuccess ? '성공' : '실패';
      return `[${log.type}] ${status}`;
    },
    scrollToBottom() {
      nextTick(() => {
        const box = this.$refs.logBox;
        if (box) {
          box.scrollTop = box.scrollHeight;
        }
      });
    }
  }
};
</script>